/* Dollpins · lista de deseos (se guarda en el navegador; guarda el "handle" del producto) */
(function () {
  var KEY = 'dp-wish';
  function read() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('dp:wish-change', { detail: a }));
  }
  var api = window.DPWish = {
    list: read,
    has: function (h) { return read().indexOf(h) >= 0; },
    toggle: function (h) {
      var a = read(), i = a.indexOf(h);
      if (i >= 0) a.splice(i, 1); else a.push(h);
      write(a);
      return i < 0;
    },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); }
  };

  function paint() {
    var l = read();
    document.querySelectorAll('[data-dp-wish-toggle]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-dp-wish-toggle')) >= 0;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('.dp-wish').forEach(function (b) { b.classList.toggle('has-items', l.length > 0); });
    document.querySelectorAll('[data-dp-wish-count]').forEach(function (n) { n.textContent = l.length; });
    document.querySelectorAll('[data-dp-wish-count-text]').forEach(function (n) { n.textContent = l.length; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dp-wish-toggle]');
    if (t) { e.preventDefault(); api.toggle(t.getAttribute('data-dp-wish-toggle')); return; }
    var o = e.target.closest('[data-dp-wish-open]');
    if (o) { e.preventDefault(); document.dispatchEvent(new CustomEvent('dp:wish-open')); }
  });
  document.addEventListener('dp:wish-change', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
})();
